export { default } from './BlogTexto';
